import { useEffect, useState } from 'react';

const useIsMobile = (breakpoint = 500) => {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

		const handleChange = () => setIsMobile(mediaQuery.matches);
		handleChange(); // Set initial value

		mediaQuery.addEventListener('change', handleChange);
		return () => mediaQuery.removeEventListener('change', handleChange);
	}, [breakpoint]);

	return isMobile;
};

export default useIsMobile;

